import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useEffect, useState } from 'react';

import ProductComparison from '@/components/flow/steps/upsell/components/acneMultiRxUpsellComponents/productComparison';
import { ITEM_IDS } from '@/consts/items';
import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

import DeepCleanseRxModal from './acneMultiRxUpsellComponents/deepCleanseRxModal';
import Disclaimers from './acneMultiRxUpsellComponents/disclaimers';
import FooterCtas from './acneMultiRxUpsellComponents/footerCtas';
import ProductCarousel from './acneMultiRxUpsellComponents/productCarousel';
import ProductComparisonFoamingGelCleanser from './acneMultiRxUpsellComponents/productComparisonFoamingGelCleanser';
import RoutineProductsWithHydroTret from './acneMultiRxUpsellComponents/routineProductsWithHydroTret';

const HydroTretMultiRxUpsell = ({
  cleanserId,
  discountAmountInCents,
  upsell,
}: {
  cleanserId: number | null;
  discountAmountInCents: number | null;
  upsell: string;
}) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    trackEvent(AnalyticsEvent.UPSELL_VIEWED, {
      upsell,
    });
  }, [upsell]);

  return (
    <>
      <div className="cur-max-w-[550px] cur-mx-auto lg:cur-px-6 lg:cur-py-8 cur-w-full">
        <Typography className="cur-text-surface-brand" size="h2">
          Special offer
        </Typography>
        <Typography className="cur-mb-4" size="h2">
          Upgrade your cleanser with Deep Cleanse<sup>Rx</sup>
        </Typography>
        {cleanserId === ITEM_IDS.largeCleanser ? (
          <ProductComparison />
        ) : (
          <ProductComparisonFoamingGelCleanser />
        )}
        <Typography className="cur-my-4" size="h2">
          <span className="cur-text-surface-brand">Tackle acne</span> from all
          angles, starting from deep in your pores
        </Typography>
        <ProductCarousel />
        <Typography className="cur-my-4" size="h2">
          Your routine, leveled up
        </Typography>
        <RoutineProductsWithHydroTret />
        <Disclaimers
          discountAmountInCents={discountAmountInCents}
          setShowModal={setShowModal}
        />
      </div>
      <FooterCtas upsell={upsell} isModalOpen={showModal} />
      <DeepCleanseRxModal setShowModal={setShowModal} showModal={showModal} />
    </>
  );
};

export default HydroTretMultiRxUpsell;
